import { IS_PRODUCTION } from 'shared/config/env';
import { cratChain, wagmiConfig } from 'shared/config/wagmi';
import { getContract } from 'viem';

import { CIT_CROWDSALE_ABI } from '../abi';

const address = {
  testnet: '0xf21f3b58d2eb70F09d820dA23be5128fa9027ACb',
  mainnet: '0x24242E5a5957A9fB636C101c7A8b74B4b56aC677',
} as const;

export const citCrowdsaleContract = getContract({
  abi: CIT_CROWDSALE_ABI,
  address: IS_PRODUCTION ? address.mainnet : address.testnet,
  client: wagmiConfig.getClient({
    chainId: cratChain.id,
  }),
});
